import { Stack, Typography } from '@mui/material';
import { useAtom } from 'jotai';

import { isLayoutMobileAtom } from '@/store/layout';

import useStyles from './Header.styles';
import type { HeaderProps } from './Header.types';

const Header = (props: HeaderProps) => {
  const { actions, actionsNewLine, children, title } = props;

  const [isLayoutMobile] = useAtom(isLayoutMobileAtom);
  const { classes } = useStyles({ actionsNewLine, isLayoutMobile });

  return (
    <header className={classes.header}>
      <Stack
        direction={actionsNewLine && isLayoutMobile ? 'column' : 'row'}
        sx={{ gap: 2 }}
        className={classes.headerInner}
      >
        <Typography variant="h1">{title}</Typography>
        {actions && (
          <Stack
            sx={{
              alignItems: 'center',
              flexDirection: 'row',
              gap: 1,
              ...(actionsNewLine && isLayoutMobile && { mb: 2, width: '100%' })
            }}
          >
            {actions}
          </Stack>
        )}
      </Stack>
      {children}
    </header>
  );
};

export default Header;
